module.exports = __webpack_public_path__ + "static/img/game4.fa55fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/game4.png
// module id = U+9i
// module chunks = 1